import React, { useContext } from "react";
import PropTypes from "prop-types";

import { useIsDispatcher } from "../../../../hooks";

import DataTable from "../../../../components/DataTable";

import {
  ALL_NOTES_QUERY,
  NOTES_PAGINATION_QUERY
} from "../../../../graphql/Notes/Notes.graphql";

import { EditEmployeeNoteForm } from "../../../../components/Employees";

import { ModalContext } from "../../../../components/ModalProvider";

import { NOTE_COLUMNS } from "../columns";

function Notes({ employeeRecId }) {
  const { setModalOpen } = useContext(ModalContext);
  const isDispatcher = useIsDispatcher();
  return (
    <DataTable
      isFixedWidth
      columns={NOTE_COLUMNS}
      dataQuery={ALL_NOTES_QUERY}
      initialSortBy={[{ id: "CreatedDateTime", desc: true }]}
      name="Note"
      paginationQuery={NOTES_PAGINATION_QUERY}
      where={
        isDispatcher
          ? {
              NoteTypeRecIdRef_not: 282,
              TableName: "Employees",
              RefRecId: parseInt(employeeRecId)
            }
          : { TableName: "Employees", RefRecId: parseInt(employeeRecId) }
      }
      onRowClick={note =>
        setModalOpen(
          true,
          <EditEmployeeNoteForm
            EmployeeRecIdRef={employeeRecId}
            note={note}
            onComplete={() => setModalOpen(false, "")}
          />
        )
      }
    />
  );
}

Notes.propTypes = {
  employeeRecId: PropTypes.number
};
export default Notes;
